import React, { Component } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import authStore from './AuthStore';
import { observer } from 'mobx-react';

const Login = observer(class Login extends Component {
    constructor(props) {
        super(props);
        this.state = {
            login: '',
            password: ''
        };

        this.handleClose = this.handleClose.bind(this);
        this.logIn = this.logIn.bind(this);
        this.close = this.close.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    componentDidMount() {
        var scope = this;
        this.checkIsUserAlreadyLogin();
        /*if (!authStore.getUserId) {
            var token = localStorage.getItem("token");
            if (token) {
                fetch('api/User/GetId', {
                    method: 'GET',
                    body: null,
                    headers: {
                        'Authorization': 'Bearer ' + token
                    },
                }).then(function (res) {
                    if (res.status === 401) {
                        scope.setState({ isAuth: false });
                    }
                    else {
                        res.json().then((result) => {
                            authStore.setUserId(result.id);
                        }).catch((err) => console.log(err));
                    }
                });
            }
        }*/
    }

    checkIsUserAlreadyLogin() {
        var token = localStorage.getItem("token");
        var scope = this;
        fetch('api/Identity/Signed', {
            method: 'GET',
            body: null,
            headers: {
                'Authorization': 'Bearer ' + token
            },
        }).then(function (res) {
            if (res.status === 401) {
                scope.setState({ isAuth: false });
                authStore.openLogin();
            }
            else {
                res.json().then((result) => {
                    if (result.token) localStorage.setItem("token", result.token);
                    authStore.setUserAuth(result.isDeveloper);
                    authStore.setIsPortal(result.isPortal);
                    authStore.setIsAdmin(result.isAdmin);
                    authStore.setUseExtendedPanel(result.useExtendedPanel);
                    authStore.setUserId(result.userId);
                    authStore.setUser({ fullName: result.fullName, roleId: result.roleId });
                    authStore.setExperimentalMode(result.useExperimentalMode);
                    authStore.closeLogin();
                    if (result.isPortal) document.location.replace('/portal');

                    var url = new URL(document.location.href);
                    var redirectUrl = url.searchParams.get("redirectUrl");
                    if (redirectUrl) document.location.replace(redirectUrl);
                    else if (authStore.getCallback) {
                        authStore.getCallback();
                    }
                    else {
                        document.location.reload();
                    }
                }).catch((err) => console.log(err));
            }
        });
    }

    handleClose() {
        //this.setState({ isOpen: false });
    }

    logIn() {
        var scope = this;
        fetch('api/Identity/Token', {
            method: 'POST',
            body: JSON.stringify({ Login: this.state.login, Password: this.state.password }),
            headers: {
                'Content-Type': 'application/json'
            }
        }).then((res) => {
            if (res.status === 401) {
                alert("АШИПКА. ПРОВЕРЬ ПАРОЛЬ ИЛИ ЗАРЕГИСТРИРУЙСЯ");
                authStore.setUserNonAuth();
            }
            else {
                res.json().then((result) => {
                    localStorage.setItem("token", result.token);
                    var tokenExpiredOnDate = new Date();
                    tokenExpiredOnDate.setMinutes(tokenExpiredOnDate.getMinutes() + 48 * 60);
                    localStorage.setItem("tokenExpiredOn", tokenExpiredOnDate.getTime().toString());
                    authStore.setUserAuth(result.isDeveloper);
                    authStore.setIsPortal(result.isPortal);
                    authStore.setIsAdmin(result.isAdmin);
                    authStore.setUseExtendedPanel(result.useExtendedPanel);
                    authStore.setUserId(result.userId);
                    authStore.setUser({ fullName: result.fullName, roleId: result.roleId });
                    authStore.setExperimentalMode(result.useExperimentalMode);
                    authStore.closeLogin();
                    if (result.isPortal) document.location.replace('/portal');
                    if (authStore.getCallback) {
                        authStore.getCallback();
                    }
                });
            }
        }).catch((err) => console.log(err));
    }

    close() {
        this.props.onSuccess && this.props.onSuccess();
    }

    handleChange = name => evt => {
        this.setState({ [name]: evt.target.value });
    }

    microsoftSignIn() {
        
        //document.location.replace('/api/Identity/SignIn?redirectUrl=' + encodeURIComponent(document.location.pathname) + '&n=' + new Date().getTime());
    }

    render() {
        return <Dialog
            onClose={this.handleClose}
            aria-labelledby="customized-dialog-title"
            open={authStore.isLoginOpened}
            maxWidth="md"
            fullWidth
        >
            <DialogTitle id="customized-dialog-title" onClose={this.handleClose}>
                Введите логин и пароль
            </DialogTitle>
            <DialogContent dividers>
                <Typography component="div">
                    <TextField
                        id="standard-login-input"
                        label="Логин"
                        autoComplete="current-login"
                        margin="normal"
                        value={this.state.login}
                        onChange={this.handleChange('login')}
                    />
                </Typography>
                <Typography component="div">
                    <TextField
                        id="standard-password-input"
                        label="Пароль"
                        type="password"
                        onKeyDown={(evt) => { evt.keyCode === 13 && this.logIn()}}
                        autoComplete="current-password"
                        value={this.state.password}
                        onChange={this.handleChange('password')}
                        margin="normal"
                    />
                </Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={this.logIn} color="primary">
                    Войти
                </Button>
            </DialogActions>
        </Dialog>;
    }
});

export default Login;
